import React, {useEffect, useState } from "react";
import { Database } from "../../config/config.js";
import { TextField, Typography, Select, MenuItem } from "@material-ui/core";
import "../../Style/Forms.css";

const Vehiculo = (props) => {
  const [cantidadVehiculos, setCantidadVehiculos] = useState([]);
  const [automotorProvincial, setAutomotorProvincial] = useState({});
  const [listaAutomotorProvincial, setListaAutomotorProvincial] = useState([])
  const [listaAutomotorMunicipal, setListaAutomotorMunicipal] = useState([])
  const [automotorMunicipal, setAutomotorMunicipal] = useState({});


  useEffect(() => {
    api();
    return () => {
      setCantidadVehiculos([])
    }
  }, []);


  const api = async () => {
    apiAutomotorProvincial()
    apiAutomotorMunicipal()
  };


  const apiAutomotorProvincial = async () =>{
    let listAutomotorProvincial = [];
    await Database.collection("AutomotorProvincial")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          listAutomotorProvincial.push(doc.data());
        });
      });
      setListaAutomotorProvincial(listAutomotorProvincial)

  }

  
  const apiAutomotorMunicipal = async () =>{
    let listAutomotorMunicipal = [];
    await Database.collection("AutomotorMunicipal")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          listAutomotorMunicipal.push(doc.data());
        });
      });
      setListaAutomotorMunicipal(listAutomotorMunicipal)

  }



  const handleChange = (event) => {
    let cantVehiculos = event.target.value
    let arrayCantidadVehiculos = Array.from({ length: cantVehiculos }, (v, i) => i)
    setCantidadVehiculos(arrayCantidadVehiculos)
  }

  const onStatusChange = (property) => ({ target: { value } }) => {
    calculoAutomotorProvincial(value, property)
    calculoAutomotorMunicipal(value, property)
  };


  const calculoAutomotorProvincial = async (valuacionEstimada, property) => {
    let newAutomotorProvincial = { ...automotorProvincial };
    let automotorProvincialBD = {}
      listaAutomotorProvincial.forEach(element => 
        {
          if (valuacionEstimada >= element.De && valuacionEstimada < element.Hasta) {
            automotorProvincialBD = element
          return
        }
        }
      );
      
    let impuestoProvincial = (automotorProvincialBD.Fijo + (automotorProvincialBD.Porcentaje ) * (valuacionEstimada - automotorProvincialBD.Excedente)) 
    newAutomotorProvincial[property] = impuestoProvincial
    setAutomotorProvincial(newAutomotorProvincial);
    props.automotorProvincial(newAutomotorProvincial)
  }


  const calculoAutomotorMunicipal = async (valuacionEstimada, property) => {
    let newAutomotorMunicipal = { ...automotorMunicipal };
    let automotorMunicipalBD = {}
    listaAutomotorMunicipal.forEach(element => 
      {
        if (valuacionEstimada >= element.De && valuacionEstimada < element.Hasta) {
          automotorMunicipalBD = element
        return
      }
      }
    );
    
    let impuestoProvincial = (automotorMunicipalBD.Fijo + (automotorMunicipalBD.Porcentaje) * (valuacionEstimada - automotorMunicipalBD.Excedente)) 
    newAutomotorMunicipal[property] = impuestoProvincial
    setAutomotorMunicipal(newAutomotorMunicipal);
    props.automotorMunicipal(newAutomotorMunicipal)
  }

  return (
    <div className="Ingresos">
      <div className="Ingresos-Title Title">
        <Typography className="Ingresos-Title__Typography">
          Vehículos (Auto/Moto/Camioneta/Camíon)
        </Typography>
      </div>
      <div className="Ingresos_Content">
        <Typography className="Ingresos-Subtitle__Typography">
          Cantidad de Vehículos
        </Typography>
        <Select
          className="Ingresos__Select Ingresos__Select--Vehiculo"
          defaultValue='DEFAULT'
          onChange={handleChange}
          inputProps={{
            name: "Tipo de Actividad",
            id: "age-native-simple",
          }}
        >
          <MenuItem value="DEFAULT" hidden >
            Seleccione la Cantidad
          </MenuItem>
          <MenuItem key={1} value={1}>1</MenuItem>
          <MenuItem key={2} value={2}>2</MenuItem>
          <MenuItem key={3} value={3}>3</MenuItem>
          <MenuItem key={4} value={4}>4</MenuItem>
          <MenuItem key={5} value={5}>5</MenuItem>
        </Select>
      </div>
      {!!cantidadVehiculos && cantidadVehiculos.length > 0 && cantidadVehiculos.map((vehiculo, index) => (
        <div key={index} className="Ingresos_Content Content_Vehiculo">
        <Typography className="Ingresos-Subtitle__Typography">
        Vehículo {vehiculo +1}
        </Typography>
        <TextField
          className="Ingresos__TextField"
          onChange={onStatusChange(index)}
          id="standard-textarea"
          placeholder="Valuación Estimada"
          type="number"
        />
      </div>
      ))}
      
    </div>
  );
};

export default Vehiculo;
